import React, { useEffect, useState } from "react";
import axios from "axios";

const FetchData = () => {
  const [users, setUsers] = useState([]);
//   http://upload.hariombusinessenterprise.com/
  useEffect(() => {
    axios.get("https://upload.hariombusinessenterprise.com/fetch_users.php")  // Replace with your actual API URL
      .then(response => {
        if (response.data.status === "success") {
          setUsers(response.data.data);
        } else {
          console.error("Error fetching data:", response.data.message);
        }
      })
      .catch(error => console.error("Error:", error));
  }, []);

  return (
    <div>
      <h2>Users List</h2>
      <ul>
        {users.map((user, index) => (
          <li key={index}>
            <strong>ID:</strong> {user.id} | 
            <strong> Name:</strong> {user.firstName} {user.lastName} | 
            <strong> Username:</strong> {user.username} | 
            <strong> Email:</strong> {user.email}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FetchData;
